// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

import { default as ControlsContainer } from '@aytm/app/stats/page/question-views/components/component/Controls'

// styles

const Controls = ({ model, data, collapsed, disabled, onToggle, onChange }) => {
  const itemTemplate = option => <span dangerouslySetInnerHTML={{ __html: option.text }}></span>
  const valueTemplate = (option, _props) => (
    <span
      dangerouslySetInnerHTML={{ __html: option ? option.label || option.text : _props.placeholder || 'Select...' }}
    ></span>
  )

  return (
    <ControlsContainer data={data} collapsed={collapsed} onToggle={onToggle}>
      <div className="p-field p-col-5">
        <Dropdown
          className="p-dropdown-rounded"
          value={model.mode}
          options={data.controls.mode.options}
          optionValue="key"
          optionLabel="text"
          itemTemplate={itemTemplate}
          valueTemplate={valueTemplate}
          fixedDropdownDir="bottom"
          disabled={disabled || data.controls.mode.disabled}
          onChange={disabled || data.controls.mode.disabled ? null : event => onChange('mode', event.value)}
        />
      </div>
    </ControlsContainer>
  )
}

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  onChange: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
